/**
 * @generated SignedSource<<70fc64a6d4f300ec9818df9dbd839a27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorLanguageButton_language$data = {
  readonly locale: Locale;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"LanguageIndicator_language">;
  readonly " $fragmentType": "EditorLanguageButton_language";
};
export type EditorLanguageButton_language$key = {
  readonly " $data"?: EditorLanguageButton_language$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageButton_language">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorLanguageButton_language",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LanguageIndicator_language"
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "b58dc7c197ee6f22629cd0925bbfbe5d";

export default node;
